import { getImageDataWithDir } from './image_dir'

// 将文件处理为合适屏幕大小的图片
export function reduceImg(file, callback) {
      getImageDataWithDir(file, (base64ImgData) => {
            const img = new Image();
            img.onload = () => {
                  const canvas = document.createElement('canvas');
                  const context = canvas.getContext('2d');
                  if (img.naturalWidth >= window.innerWidth && img.naturalHeight >= window.innerHeight) {
                        const naturalWidth = img.naturalWidth;
                        const naturalHeight = img.naturalHeight;

                        let widthFactor = naturalWidth / window.innerWidth;
                        let heightFactor = naturalHeight / window.innerHeight

                        let maxFactor = Math.max(widthFactor, heightFactor);

                        let maxWidth = naturalWidth / maxFactor;
                        let maxHeight = naturalHeight / maxFactor;

                        canvas.width = maxWidth;
                        canvas.height = maxHeight;

                        context.drawImage(img, 0, 0, naturalWidth, naturalHeight, 0, 0, maxWidth, maxHeight);
                  } else {
                        canvas.width = img.naturalWidth;
                        canvas.height = img.naturalHeight;
                        context.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight, 0, 0, img.naturalWidth, img.naturalHeight)

                  }
                  callback && callback(canvas.toDataURL("image/jpeg", 1));
            }
            img.src = base64ImgData
      });
}